import {LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {inputStyles} from "@/components/input/input.styles.ts";
import {RequiredValidator, Validator} from "@/components/validators/validators.ts";
import {AutocompleteMixin, SuggestItem} from "@/components/autocomplete/autocomplete-mixin.ts";
import {autocompleteStyles} from "@/components/autocomplete/autocomplete.styles.ts";
import {labelStyles} from "@/components/label/label.styles.ts";



@customElement('sbk-autocomplete-input-street')
export class SbkAutocompleteInputStreet extends AutocompleteMixin(LitElement) {

  static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

  @property({attribute: 'zip-input-value'})
  zipInputValue: string = ''

  @property({attribute: 'city-input-value'})
  cityInputValue: string = ''

  validatorMapper: {
    [key: string]: Validator
  } = {
    'required': RequiredValidator,
  }

  static get styles() {
    return [
      autocompleteStyles,
      labelStyles,
      inputStyles
    ];
  }

  async _querySuggestions(inputValue: string) {
    if (inputValue.length < 3) {
      this.suggestions = [];
      this.close(true)
      return;
    }

    const urlParams = new URLSearchParams({
      "zipCode": this.zipInputValue,
      "city": this.cityInputValue,
      "street": inputValue.toLowerCase(),
    });
    await fetch('/ajax/middleware/searchAddress' + '?' + urlParams)
        .then((response) => {
          return response.text()
        })
        .then((data) => {
          const parsedSuggestions = JSON.parse(data);
          const allSuggestions: SuggestItem[] = [];
          Object.entries(parsedSuggestions).forEach((suggestion) => {
            allSuggestions.push( {
              label: <string> suggestion[1],
              value: <string> suggestion[1]
            } );
          });
          this.suggestions = allSuggestions;
        })
    await this.updateComplete;
  }
}